<nav class="navbar shadow-sm">
  <!-- Logo -->
  <div class="logo d-flex align-items-center" (click)="navigateHome()">
    <span class="logo-icon"><img src="logo_no_background.png" width="50px" height="50px" /></span>
    <span class="logo-text ms-2">Medvisit</span>
  </div>

  <!-- Mobile toggle -->
  <button class="menu-toggle" (click)="toggleMenu()">☰</button>

  <!-- Links -->
  <ul class="nav-links" [class.open]="isMenuOpen">
    <!--    <li><a routerLink="/dashboard/booking-list" routerLinkActive="active">Bookings</a></li>-->
    <!--    <li><a routerLink="/dashboard/doctor-profile" routerLinkActive="active">Profile</a></li>-->
    <li>
      <a routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Login</a>
    </li>
    <li><a routerLink="/register">Register</a></li>
  </ul>
</nav>

<main class="content">
  <router-outlet></router-outlet>
</main>